import { IApplicationState } from '../types/redux';

export function priceForMeterSelector(state: IApplicationState) {
  return state.newbuilding.priceForMeterFromDeveloperDisplay;
}
